import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'
import { PseudoFile } from './../../app/utils.service'

@Injectable()
export class UploadFileService {
    constructor(private http: HttpClient) {}

    uploadfile(signedUrl: string, file: PseudoFile | { blob: unknown }) {
        return firstValueFrom(this.http.put(signedUrl, file.blob))
    }
}
